module.exports = __webpack_public_path__ + "img/Fatturato_2022-ENG.84a91bae.png";